/**
 * Resolve catalogue layer key from a clicked Object3D (walk parents).
 */
export function resolveLayerKeyFromObject(object, knownKeys) {
  const keys =
    knownKeys instanceof Set
      ? knownKeys
      : new Set(Array.isArray(knownKeys) ? knownKeys : Object.keys(knownKeys || {}));

  let node = object;
  while (node) {
    const tagged = node.userData?.mdvLayerKey;
    if (tagged) return tagged;
    if (node.name && keys.has(node.name)) return node.name;
    node = node.parent;
  }
  return null;
}

/** Stamp every node under root so raycast hits resolve back to the layer. */
export function tagObjectWithLayerKey(root, layerKey) {
  if (!root || !layerKey) return;
  root.traverse((obj) => {
    if (!obj.userData) obj.userData = {};
    obj.userData.mdvLayerKey = layerKey;
  });
}
